'use client';

import { SkeletonBar } from '@petsmart-ui/sparky';

import { getAfterpayConfig } from '@libs/common-next';
import { getCurrency, getLocale } from '@libs/core';

import { useAfterpay, useAfterpayVisibility } from '../../model';

import './Afterpay.scss';

export const Afterpay = () => {
    const afterPay = useAfterpay();

    const locale = getLocale();
    const { mpid, placementId } = getAfterpayConfig();
    const currency = getCurrency();

    const { containerRef, isPlacementVisible, hasTimedOut } = useAfterpayVisibility(afterPay?.sku);

    return (
        <div className="afterpay" ref={containerRef}>
            {afterPay && !hasTimedOut && (
                <div
                    data-testid="afterpay"
                    style={isPlacementVisible ? undefined : { display: 'none' }}
                    dangerouslySetInnerHTML={{
                        __html: `
                <square-placement
                    data-mpid="${mpid}"
                    data-placement-id="${placementId}"
                    data-page-type="PDP"
                    data-modal-id="${locale.replace('-', '_')}-petsmart"
                    data-amount="${afterPay.price}"
                    data-currency="${currency}"
                    data-consumer-locale="${locale}"
                    data-item-skus="${afterPay.sku}"
                    data-item-categories="${afterPay.primaryCategoryName ?? ''}"
                    data-is-eligible="${afterPay.isEligible}"
                    >
                </square-placement>
            `,
                    }}
                />
            )}
            {!isPlacementVisible && !hasTimedOut && (
                <SkeletonBar className="afterpay-skeleton" data-testid="afterpay-skeleton" />
            )}
        </div>
    );
};
